import React from "react";
import {SetStateFn} from "@/utils/SetStateUtils";
import {Modal} from "peggirkit";
import {useIntl} from "react-intl";
import EmployeeDashboard from "@widgets/timeRegistration/EmployeeDashboard";

type Props = {
    show: boolean,
    setShow: SetStateFn<boolean>,
};

const EmployeeModal = ({show, setShow}: Props) => {
    const intl = useIntl();

    return (
        <Modal
            title={intl.formatMessage({id: "employeeLogin"})}
            show={show}
            onClose={() => setShow(false)}
        >
            <EmployeeDashboard
                wrapInCard={false}
            />
        </Modal>
    );
};

export default EmployeeModal;